import React, { useState } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import Snacks from '../../../../../assets/images/OUR SERVICES/11.Ready to eat snacks.png';
import EnquiryModal from '../../../../../common/pages/enquiryModal';
const Snack = () => {
    const [modal, setModal] = useState(false);
    const toggleModal = () => setModal(!modal);
    return (
        <React.Fragment>

            <section className="section bg-light py-5" id="features">
                <Container>
                    <Row className="align-items-center gy-4">
                        <div className="text-muted">
                            <div className="text-center ">
                                <h2 className="fw-bold mt-5" style={{ fontSize: "2rem", color: "#F15A29" }}>Ready To Eat</h2>

                            </div>
                        </div>
                    </Row>
                </Container>
            </section>

            <section className="section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10} sm={10}>
                            <Row className="align-items-center gy-4">
                                <Col lg={6} md={12}>
                                    <img
                                        src={Snacks}
                                        alt="Premium Corporate Gifts"
                                        className="img-fluid rounded"
                                        style={{ width: "100%", height: "auto" }}
                                    />
                                </Col>
                                <Col lg={6} md={12}>

                                    <div className="text-black">
                                        <p><strong>Haldiram Snacks</strong> – Enjoy a wide range of traditional Indian snacks, including namkeens, bhujia, soan papdi, and ready-to-eat meal packs.</p>
                                        <p><strong>Lays Chips</strong> – Crispy and flavorful potato chips available in multiple flavors like Classic Salted, Magic Masala, and American Cream & Onion.</p>
                                        <p><strong>Britannia Bakery & Biscuits</strong> – Delicious biscuits, cakes, and rusks, including popular choices like Good Day, Bourbon, and Marie Gold.</p>
                                        <p><strong>Parle Snacks & Biscuits</strong> – Iconic treats like Parle-G, Monaco, KrackJack, Hide & Seek, and various other crispy and tasty snack options.</p>
                                        <p><strong>Healthy Snack Options</strong> – A variety of nutritious ready-to-eat options, including baked chips, protein bars, and multigrain snacks.</p>
                                        <p><strong>Instant Noodles & Ready Meals</strong> – Quick and tasty options like Maggi, Yippee, and Haldiram’s instant meal bowls for a convenient snack.</p>
                                    </div>
                                </Col>

                            </Row>
                        </Col>
                    </Row>
                </Container>
                <EnquiryModal isOpen={modal} toggle={toggleModal} />
            </section>
            <section className="section  py-5" style={{ backgroundColor: " rgb(52, 81, 159)" }} id="features">
                <Container>
                    <Row className="justify-content-center">
                        <div className='text-center '>
                            <Button className='px-4 py-2 fw-bold' onClick={toggleModal}
                                style={{ background: "rgb(238, 99, 82)", borderRadius: "20px", color: "white", fontSize: "20px" }}
                            >
                                Enquiry Now
                            </Button>
                        </div>
                    </Row>
                </Container>
            </section>
        </React.Fragment >
    );
};

export default Snack;